<template>
    <div class="blackBg  animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="week">第 {{ nowWeek }} 周</span>
            <span class="teamName">{{ teamName ? teamName : 'XXX' }}</span>
        </div>
        <div class="cardBg" id="cardBg" @click="clearTimeFn">
            <div class="contentBox">
                <div class="weekTraining">
                    <ul class="header" v-if="scheduleData && scheduleData.schedule && scheduleData.schedule.length">
                        <li :style="{'width' : (100 / scheduleData.schedule.length) + '%'}"
                            v-for="(i,key) in scheduleData.schedule"
                            :class="today==i.date?'today':''" @click="dayWorkDetail(i)">
                            <p class="top">{{ i.date.split('/')[1] + '/' + i.date.split('/')[2] }}
                                {{ weekInd[key] }}</p>
                            <p class="dayMsg">
                                <span>{{ i.task.title }}</span>
                                <span>场地: {{ i.task.field }}</span>
                                <span>RPE: {{ i.task.rpe }}</span>
                            </p>
                            <img v-if="$global.formatDate(new Date(),'yyyy/MM/dd',true)==i.date"
                                 :src="i.task&&i.task.theme?require('@/assets/img/trainingIcon/'+i.task.theme+'.svg'):''"
                                 alt="">
                            <img v-else
                                 :src="i.task&&i.task.theme?require('@/assets/img/trainingIcon/'+i.task.theme+'Col.svg'):''"
                                 alt="">
                        </li>
                    </ul>
                    <div style="clear: both"></div>
                </div>
                <div class="todayWork">今日工作 <span><i>{{ todaySchedule.length }}</i> 项</span></div>
                <div>
                    <div class="bottomBox" :class="{anim:ind==0}" v-for="(i,ind) in todaySchedule">
                        <div class="itemListBox">
                            <div class="top">
                                <div class="titleMsg">
                                    <p><span class="label">标题</span><span class="value">{{ i.title }}</span></p>
                                    <p><span class="label">时间</span><span
                                        class="value">{{ i.start + ' ~ ' + i.end }}</span>
                                    </p>
                                    <p v-if="i.itemType = 'training'"><span class="label">训练时长 </span><span
                                        class="value"
                                        style="width: 6vw;margin-left: .5vw">{{ timeFn(i.start, i.end) }} 分钟</span>
                                    </p>
                                </div>
                                <div class="staffMsg">
                                    <span class="label">教练组</span>
                                    <div class="coaching">
                                        <p v-if="i.coaching" v-for="itemCoaching in i.coaching">
                                        <span class="imgBox">
                                            <img v-if="itemCoaching.avatar" :src="itemCoaching.avatar" alt="">
                                            <img class="defaultHead" v-else src="../assets/img/updateImg/headImg.svg"
                                                 alt="">
                                        </span>
                                            <span class="name">{{ itemCoaching.name }}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="mes">
                                    <p><span class="label">描述</span><span class="value">
                                    <pre>{{ i.desc }}</pre>
                                    </span>
                                    </p>
                                </div>
                            </div>
                            <div style="clear: both"></div>
                            <div class="bottom" v-if="i.exercises && i.exercises.length">
                                <img v-if="i.exercises.length>3" src="../assets/img/updateImg/arrow_left.svg" alt=""
                                     class="left">
                                <img v-if="i.exercises.length>3" src="../assets/img/updateImg/arrow_right.svg"
                                     alt=""
                                     class="right">
                                <div class="practice-list-box">
                                    <div class="practice-list-item" v-for="exercises in i.exercises">
                                        <img v-if="exercises.videoUrl" class="videoIcon"
                                             src="../assets/img/icon/videoIcon.svg" alt="">
                                        <div class="list-item-img">
                                            <img
                                                v-if="exercises.drawingThumbnail != '' && exercises.drawingThumbnail != null && exercises.drawingThumbnail != undefined "
                                                :src="exercises.drawingThumbnail">
                                            <img v-else src="../assets/img/reportImg/scheduleWorkItem.png">
                                        </div>
                                        <p class="list-item-tit-msg">{{ exercises.title }}</p>
                                        <div class="list-item-tags">
                                            <p class="list-item-tags-col"><i
                                                class="icon-user"></i><span>{{ labelVal(exercises.tags, "tags") }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="clear: both"></div>
                        </div>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import photoCard from '../components/photoCard.vue'

export default {
    name: "trainingReport",
    components: {
        photoCard
    },
    computed: {
        teamId() {
            return this.$store.state.teamId;
        }
    },
    data() {
        return {
            teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
            nowWeek: '',//当前周
            today: this.$global.formatDate(new Date(), 'yyyy/MM/dd', new Date()),//今天
            // today: '2021-07-19',//今天
            todaySchedule: [],//今日日程
            scheduleData: {},//日程
            scrollDomHeight: 0,//滚动距离
            scrollTime: 0,//滚动时间
            time: null,//定时器
            height: 1,
            labelList: {},//教案标签
            date: new Date(),//今天、明天、昨天
            weekInd: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        }
    },
    watch: {
        teamId: {
            handler(val, old) {
                if (val != old) {
                    this.teamName = this.$store.state.teamName.split('_')[0];//梯队名称
                    this.scrollDomHeight = 0;//滚动距离
                    this.scrollTime = 0//滚动时间
                    clearInterval(this.time)
                    this.info()
                }
            },
            deep: true
        },
    },
    mounted() {
        this.time = null;
        this.info();
    },
    methods: {
        info() {
            this.nowWeekFn();
        },
        //当前周
        nowWeekFn() {

            this.$server.nowWeek()
                .then((res) => {
                    this.nowWeek = res.data;
                })
            let data = {
                teamId: this.teamId,
                // teamId: '5fbb328e99853c35e99eb2cb',
                weeks: this.getWeekDay().join(','),
            }
            this.scheduleFn(data);
        },
        //日程list
        scheduleFn(data) {
            this.$server.weekSchedule(data)
                .then((res) => {
                    this.scheduleData = res.data[0];
                    // console.log(this.scheduleData)

                    let week = this.scheduleData.schedule ? this.scheduleData.schedule : [];
                    let obj = {};
                    week.map(item => {
                        obj[item.date] = item
                    })
                    this.todaySchedule = obj[this.today] ? obj[this.today].workitem : [];

                    this.scroll();
                })
        },
        //滚动
        scroll() {
            var hScrollTop = document.getElementById('cardBg').scrollTop;
            var hScrollHeight = document.getElementById('cardBg').scrollHeight;
            var offsetHeight = document.getElementById('cardBg').offsetHeight;

            // console.log(hScrollTop + " " + hScrollHeight + " " + this.height + ' ' + offsetHeight);
            if ((offsetHeight + hScrollTop) >= hScrollHeight) {//滚动条已经到了容器底部
                this.height = -1;
            }else if (hScrollTop === 0) {
                this.height = 1;
            }

            var h = hScrollTop + this.height;
            document.getElementById('cardBg').scrollTop = h;
            this.time = window.requestAnimationFrame(this.scroll)
        },
        //教案标签序列化
        labelVal(value, type) {
            let labelStr = [];
            if(value && value.length){
                value.map(item => {
                    labelStr.push(item.name)
                })
            }
            return labelStr.join(',')
        },

        // 获取本周的日期
        getWeekDay() {
            let dateString = this.$global.formatDate(new Date(), 'yyyy/MM/dd', true);//当天的日期，例如2020-2-28
            let presentDate = new Date(dateString);
            let today = presentDate.getDay() !== 0 ? presentDate.getDay() : 7;

            return Array.from(new Array(7), (val, index) => {
                return this.$global.formatDate(new Date(presentDate.getTime() - (today - index - 1) * 24 * 60 * 60 * 1000), 'yyyy/MM/dd', true);
            });
        },
        timeFn(start, end) {
            let startArr = start.split(':');
            let endArr = end.split(':');
            console.log(((endArr[0] - startArr[0]) * 60) + (endArr[1]) + (60 - startArr[1]))
            return ((endArr[0] - startArr[0]) * 60) + (endArr[1] * 1) + (60 - startArr[1])
        },

        dayWorkDetail(item) {
            this.todaySchedule = item.workitem
        },
        clearTimeFn() {
            console.log('执行取消事件')
            window.cancelAnimationFrame(this.time)
            return false;
        }
    },
    beforeDestroy() {
        window.cancelAnimationFrame(this.time)
    }
}
</script>

<style scoped lang="less">
.cardTit {
    background-image: url("../assets/img/updateImg/head_2.png");
    position: relative;
    font-size: 30px;
    margin-top: 1vw;

    .week, .time {
        font-family: PingFangMedium;
        color: #fff;
        display: inline-block;
        line-height: 120px;
        position: absolute;
    }

    .week {
        line-height: 130px;
        left: 2vw;
    }
}

.cardBg {
    width: 100%;
    height: calc(100% - 100px);
    /*max-height: calc(100% - 100px);*/
    overflow-y: auto;
    color: #fff;

    .contentBox {
        height: 100%;
        position: relative;
        padding-top: 1vw;

        .headCoachName {
            display: inline-block;
            font-size: 26px;
            float: left;
            margin-top: 2vw;
            padding-left: 1.5vw;
        }

        .headCoachImg {
            margin-left: 1.5vw;
            margin-bottom: 1vw;
        }

        .time {
            float: right;
            margin-right: 2vw;
            margin-top: 1.5vw;
            display: inline-block;
            font-size: 26px;

            span {
                margin-left: .5vw;
                color: var(--primary-color);
                font-size: 50px;
                font-family: akrobatBold;
            }

            i {
                font-style: normal;
                font-size: 20px;
                color: rgba(255, 255, 255, .8);
            }
        }

        .scroll {
        }
    }
}

.todayWork {
    line-height: 3vw;
    margin-bottom: 2px;
    font-size: 25px;
    padding-left: 2vw;

    span {
        font-size: 18px;

        i {
            color: var(--primary-color);
            padding-left: 1vw;
            padding-right: .5vw;
            font-family: akrobatBold;
            font-style: normal;
            font-size: 50px;
        }
    }
}

.bottomBox {
    margin-top: 2px;

    &:first-child {
        margin-top: 0;
    }

    padding: 1.5vw;

    .itemListBox {
        font-size: 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);

        .top {
            padding: 1vw;

            .titleMsg, .mes {

                p {
                    padding-bottom: 1.5vw;
                    margin-right: 3vw;
                    float: left;

                    span {
                        float: left;
                    }
                }

                .label {
                    min-width: 3vw;
                    color: rgba(255, 255, 255, .65);
                }

                .value {
                    width: calc(100% - 3vw);
                    padding-right: 1vw;
                }
            }

            .staffMsg {
                clear: both;

                .label, .coaching {
                    float: left;
                }

                .label {
                    width: 5vw;
                    margin-right: .2vw;
                    color: rgba(255, 255, 255, .65);
                }

                .coaching {
                    width: calc(100% - 6vw);

                    p {
                        height: 3vw;
                        margin-right: 2vw;
                        float: left;
                        padding-right: 1vw;
                    }

                    .imgBox, .name {
                        float: left;
                    }

                    .name {
                        color: #fff;
                        margin-top: 0.2vw;
                        width: calc(100% - 3vw);
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }

                    .imgBox {
                        margin-top: -0.5vw;
                        width: 2.5vw;
                        height: 2.5vw;
                        overflow: hidden;
                        display: inline-block;
                        border-radius: 50%;
                        margin-right: .5vw;

                        img {
                            width: 100%;
                        }

                        .defaultHead {
                            height: 100%;
                        }
                    }
                }
            }
        }

        .bottom {
            width: 100%;
            clear: both;
            border-top: 1px rgba(255, 255, 255, 0.44) dotted;
            text-align: center;
            position: relative;

            .practice-list-box {
                width: calc(100% - 6vw);
                margin-left: 3vw;
                margin-right: 3vw;
                white-space: nowrap;
                overflow-x: auto;
            }

            .left, .right {
                position: absolute;
                height: 12%;
                top: 44%;
            }

            .left {
                left: 0;
            }

            .right {
                right: 0;
            }
        }
    }
}

.practice-list-item {
    margin-top: 1.5vw;
    margin-right: 2vw;
    margin-left: 2vw;
    display: inline-block;
    width: calc(33.3% - 4vw);
    cursor: pointer;
    background: rgba(216, 216, 216, .1);
    position: relative;
    color: #fff;

    .videoIcon {
        position: absolute;
        top: 1vw;
        right: 1vw;
        width: 2vw;
    }

    .list-item-tit-msg {
        text-align: left;
        height: 3vw;
        width: 100%;
        padding-left: 1vw;
        padding-right: 1vw;
        white-space: normal;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        autoprefixer: off;
        -webkit-box-orient: vertical;
        autoprefixer: on;
        padding-top: .5vw;
    }

    .list-item-img {
        padding: 1vw 1vw 0;
        box-sizing: border-box;
        height: 17.2vw;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .list-item-tags {
        clear: both;
        text-align: left;
        padding-left: .6vw;
        padding-right: .5vw;
        box-sizing: border-box;

        p {
            width: 50%;
            display: inline-block;
        }

        i {
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-bottom: -3px;
        }

        i.icon-user {
            background: url("../assets/img/updateImg/hot.svg") no-repeat center center;
            background-size: 100% 100%;
        }

        .list-item-tags-col {
            white-space: nowrap;
            overflow: hidden;

            span {
                padding-left: .3vw;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(255, 255, 255, .7);
            }
        }
    }
}

.weekTraining {
    clear: both;
    border: 1px solid rgba(151, 151, 151, .6);
    box-sizing: border-box;
    height: 18vw;
    font-size: 19px;
    color: rgba(255, 255, 255, .7);
    margin: 1.5vw;

    .header {
        box-sizing: border-box;
        width: 100%;
        height: calc(100%);

        .today {
            color: var(--primary-color);
        }

        li {
            position: relative;
            height: calc(100%);
            width: 12.5%;
            float: left;
            border-right: 1px solid rgba(151, 151, 151, .6);

            &:last-child {
                border-right: none;
            }

            img {
                position: absolute;
                bottom: 1vw;
                width: 35%;
                left: calc(50% - (35% / 2));
            }
        }

        .top {
            text-align: center;
            border-bottom: 1px solid rgba(151, 151, 151, .6);

            height: 2.5vw;
            line-height: 2.5vw;
        }

        .dayMsg {
            padding-top: 1vw;

            span {
                display: block;
                text-align: left;
                padding-left: 1vw;
                line-height: 1.5vw;
            }
        }
    }
}
</style>
